import { useState } from 'react';
import { Box, Button, Popover, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { format } from 'date-fns';

import { colors } from '@src/styles';
import { DateRangePicker } from '@src/components';

export type TDateRangeField = {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
};

const formatDate = (date: Date | null): string => (date ? format(date, 'dd/MM/yy') : '—');

export const DateRangeField = ({ startDate, endDate, onStartDateChange, onEndDateChange }: TDateRangeField) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  return (
    <>
      <Button
        onClick={(event) => setAnchorEl(event.currentTarget)}
        startIcon={<CalendarMonthIcon sx={{ fontSize: 18 }} />}
        sx={{
          height: 36,
          paddingX: 1.25,
          borderRadius: '4px',
          border: `1px solid ${isOpen ? colors.primary.yellow : colors.background.secondary}`,
          color: colors.primary.white,
          textTransform: 'none',
          fontSize: '13px',
          fontWeight: 400,
          whiteSpace: 'nowrap',
          '&:hover': { borderColor: colors.primary.yellow, backgroundColor: 'transparent' },
        }}
      >
        {formatDate(startDate)} — {formatDate(endDate)}
      </Button>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: {
              marginTop: 1,
              padding: 2,
              backgroundColor: colors.brand.surface,
              border: `1px solid ${colors.brand.line}`,
              borderRadius: '12px',
              backgroundImage: 'none',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography
            sx={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '10px',
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              color: colors.brand.textMuted,
            }}
          >
            Período
          </Typography>
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            startDateLabel="De"
            endDateLabel="Até"
          />
        </Box>
      </Popover>
    </>
  );
};
